import ToggleButton from '../../../components/common/toggle-button';
import React, { useState, useEffect } from 'react';
import AccordionTile from '../Accordion';
import { CustomInput } from '../../../components/common';
import { Package, useUpdatePackage } from '../../../hooks/useClients';

interface DependentsProps {
  packageData: Package;
  setSaveDataModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const Dependents: React.FunctionComponent<DependentsProps> = ({ packageData, setSaveDataModal }): JSX.Element => {
  const { updatePackage } = useUpdatePackage(packageData.client_id!, packageData.id!);
  const [isDependentsEnable, setIsDependentsEnable] = useState<boolean>(false);
  const [dependentCount, setDependentCount] = useState<number>(3);
  const [memberCanAddDependents, setMemberCanAddDependents] = useState<boolean>(false);
  const [enableSaveOption, setEnableSaveOption] = useState(false);
  const [errors, setErrors] = useState<any>({});

  const handleSave = () => {
    const payload = {
      dependents_configuration: {
        enabled: isDependentsEnable,
        dependent_count: +dependentCount,
        members_can_add_dependents: memberCanAddDependents,
      },
    };
    updatePackage.mutate(payload);
  };

  useEffect(() => {
    if (packageData?.dependents_configuration) {
      setIsDependentsEnable(packageData.dependents_configuration?.enabled);
      setDependentCount(packageData.dependents_configuration?.dependent_count);
      setMemberCanAddDependents(packageData.dependents_configuration?.members_can_add_dependents);
      setEnableSaveOption(false);
    }
  }, [packageData]);

  useEffect(() => {
    setSaveDataModal(enableSaveOption);
  }, [enableSaveOption]);

  return (
    <AccordionTile
      setStatus={(data: boolean) => {
        !enableSaveOption && setEnableSaveOption(true);
        setIsDependentsEnable(data);
      }}
      Label={'DEPENDENTS'}
      buttonText={'SAVE'}
      status={isDependentsEnable}
      id={'Dependents'}
      initialstatus={true}
      onButtonClick={handleSave}
      disableButton={enableSaveOption}
      InnerComponent={
        <div className={'grid grid-cols-2 gap-4 py-2.5'}>
          <div className="col-span-1">
            <CustomInput
              inputType="text"
              Label="Dependent Count"
              value={dependentCount}
              setValue={(data) => {
                setDependentCount(data);
                if (parseInt(data, 10) < 1) {
                  setErrors({ dependent_count: { message: 'Enter 1 (one) or more' } });
                  setEnableSaveOption(false);
                  return;
                }
                setErrors({});
                setEnableSaveOption(true);
              }}
              Error={!!errors?.dependent_count?.message?.length}
              ErrorMessage={errors.dependent_count?.message}
              dataTestId="dependent-count"
            />
          </div>
          <div className="col-span-1 flex">
            <div className="text-dark-blue mr-2 flex items-center text-sm font-medium leading-4">
              Members Can Add Dependents
            </div>
            <div className="flex items-center px-3">
              <ToggleButton
                status={memberCanAddDependents}
                setStatus={(data) => {
                  setEnableSaveOption(true);
                  setMemberCanAddDependents(data);
                }}
                initialstatus={true}
                id={'member-can-add-dependents'}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default Dependents;
